import { render, staticRenderFns } from "./BtnDetail.vue?vue&type=template&id=6a306552"
import script from "./BtnDetail.vue?vue&type=script&lang=js"
export * from "./BtnDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports